export const FORM_STATE = {
    EDIT: 'edit',
    VIEW: 'view',
  };